export const CompaniesHouseCompanyStatus = {
    ACTIVE: 'active',
    DISSOLVED: 'dissolved',
    OPEN: 'open'
};